module.exports = __webpack_public_path__ + "static/icon-ui-e0c037b7f6118611b3996a25f007815b.png";